// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"510":"67ed3aad","855":"740cd9e1"}[chunkId] + ".js";
};